import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { GammaPetitionDetailsDataExperimentsQuery } from './experiments.graphql';
import { GammaPetitionDetailsDataExperiments } from './experiments.graphql';

export async function fetchGammaPetitionDetailsExperiments(
	utilityContext: UtilityContext,
): Promise<GammaPetitionDetailsDataExperimentsQuery['experiments']> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<GammaPetitionDetailsDataExperimentsQuery>({
		query: GammaPetitionDetailsDataExperiments,
		rejectOnError: true,
	});
	return data.experiments;
}
